<table mat-table #genericTable="matSort" [dataSource]="table_dataSource" matSort [matSortActive]="table_sort_active" (matSortChange)="customSort($event)" matSortDirection="asc">
  <caption></caption>
  <ng-container *ngFor="let column of table_Columns" [matColumnDef]="column.columnDef">
    <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header [style.background-color]="sort?.active==column.columnDef?'#F0F5FF':null" [disabled]="column.sortHeader=='no'?true:false">{{ column.header }}</th>
    <td mat-cell *matCellDef="let row" [innerHTML]="column.cell(row)|safeHTML" [style.background-color]="sort?.active==column.columnDef?'#F0F5FF':null"></td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
<div *ngIf="dataSource.data?.length === 0" class="align-items-center text-align-norecords">{{noRecords}}</div>
<div>
  <mat-paginator class="print-content-hide" [pageSize]="pagesize" [pageSizeOptions]="pagelistarray"
                 aria-label="Page numbers" appHostListenerClick>
  </mat-paginator>
</div>
